import { render, staticRenderFns } from "./supportMeasures.vue?vue&type=template&id=3927ff96&scoped=true&"
import script from "./supportMeasures.vue?vue&type=script&lang=js&"
export * from "./supportMeasures.vue?vue&type=script&lang=js&"
import style0 from "./supportMeasures.vue?vue&type=style&index=0&id=3927ff96&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3927ff96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3927ff96')) {
      api.createRecord('3927ff96', component.options)
    } else {
      api.reload('3927ff96', component.options)
    }
    module.hot.accept("./supportMeasures.vue?vue&type=template&id=3927ff96&scoped=true&", function () {
      api.rerender('3927ff96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/shortResume/supportMeasures.vue"
export default component.exports